export default __webpack_public_path__ + "static/media/car_price_predictor.f038bd98.PNG";